export default {
  DRUG_ALLERGY: 'Drug Allergy',
  FOOD_ALLERGY: 'Food Allergy',
  INSECT_ALLERGY: 'Insect Allergy',
  LATEX_ALLERGY: 'Latex Allergy',
  MOLD_ALLERGY: 'Mold Allergy',
  PET_ALLERGY: 'Pet Allergy',
  POLLEN_ALLERGY: 'Pollen Allergy',
};
